import React from 'react';
import "./findcard.scss"
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const FindByCard = () => {
    const history = useNavigate()
    const client_Id = localStorage.getItem("client_Id");
    const recuiterId = localStorage.getItem("recuiter_Id");
    const couponCode = "NBF991";
    const RecuitercouponCode = "NBF155";
    const copyCouponCode = () => {
        navigator.clipboard.writeText(couponCode).then(() => {
            // alert("Coupon code copied to clipboard!");
            toast.success('Coupon code copied', {
                position: 'top-center',
            })
        }).catch(err => {
                console.error("Failed to copy coupon code: ", err);
            });
    };
    const recuiterCopyCouponCode = () => {
        navigator.clipboard.writeText(RecuitercouponCode).then(() => {
            // alert("Coupon code copied to clipboard!");
            toast.success('Coupon code copied', {
                position: 'top-center',
            })
        }).catch(err => { 
            console.error("Failed to copy coupon code: ", err);
        });
    };
    const handlewithoutlogin = (item) => {
        if (item == "find-project") {
            // history("/view-all-projects")
            history("/all-project-posted")
        }
        if (item == "find-job") {

            history("/hire-talent")

        }
        if (item == "post-job-project") {

            history("/job-recuiter-login")

        }
        if (item == "find-talent") {

            history("/all-freelancer")

        }
        if (item == "Post-the-Project") {
            history("/project-posting")
        }
        if (item == "Post-the-Job") {
            history("/recuiter-profile/post_a_job")
        }
    }

    return (
        <>
            <div className="find-by-card">
                <div className="find-by-card-container">
                    {client_Id ? (<>
                        <div onClick={() => handlewithoutlogin("find-job")} className="find-card recuiter-find-card">
                            <img src="/image/findcardimg1.webp" alt="" />
                            <div className="find-by-card-content">
                                <div className="find-by-card-content-data">
                                    <h5>Find Job</h5>
                                    <p>Secure Your Ideal Position.</p>
                                </div>
                                <div className="find-by-card-content-icon">
                                    <TrendingFlatIcon />
                                </div>
                            </div>

                        </div>
                        <div onClick={() => handlewithoutlogin("find-project")} className="find-card recuiter-find-card">
                            <img src="/image/findcardimg2.webp" alt="" />
                            <div className="find-by-card-content">
                                <div className="find-by-card-content-data">
                                    <h5>Find Projects</h5>
                                    <p>Discover Your Next Big Project.</p>
                                </div>
                                <div className="find-by-card-content-icon">
                                    <TrendingFlatIcon />
                                </div>

                            </div>


                        </div>
                        <div className="   couponcodemen">
                            <img src="/image/couponcodemen.png" alt="" />
                            <div className="find-by-card-content">
                                <div className="find-by-card-content-data">
                                    <h4>Get 10% off*</h4>
                                    <h5>Buy Premium Subscription <br /> and earn more.</h5>
                                    <h6>Use Coupon code</h6>
                                    <div className='coupon-code-name'>{couponCode}</div>
                                    <div style={{ fontSize: "13px", paddingTop: "5px", cursor: "pointer", color: "navy" }} onClick={copyCouponCode}>Copy Coupon Code</div>
                                    {/* <button className=" btn-link" >
                                        
                                    </button> */}
                                </div>
                                <div className="find-by-card-content-icon">
                                    <TrendingFlatIcon />
                                </div>
                            </div>
                        </div>

                    </>) :
                        recuiterId ? (<>
                            <div onClick={() => handlewithoutlogin("Post-the-Project")} className="find-card  ">
                                <img src="/image/findcardimg1.webp" alt="" />
                                <div className="find-by-card-content">
                                    <div className="find-by-card-content-data">
                                        <h5>Post Project</h5>
                                        <p>Post project and find the Right Talent!.</p>
                                    </div>
                                    <div className="find-by-card-content-icon">
                                        <TrendingFlatIcon />
                                    </div>
                                </div>

                            </div>
                            <div onClick={() => handlewithoutlogin("Post-the-Job")} className="find-card  ">
                                <img src="/image/findcardimg2.webp" alt="" />
                                <div className="find-by-card-content">
                                    <div className="find-by-card-content-data">
                                        <h5>Post Job</h5>
                                        <p>Post and Hire the Best!.</p>
                                    </div>
                                    <div className="find-by-card-content-icon">
                                        <TrendingFlatIcon />
                                    </div>

                                </div>


                            </div>
                            <div onClick={() => handlewithoutlogin("find-talent")} className="find-card  ">
                                <img src="/image/findcardimg3.webp" alt="" />
                                <div className="find-by-card-content">
                                    <div className="find-by-card-content-data">
                                        <h5>Find Talent</h5>
                                        <p>Discover Top Talent to Elevate Your Projects!.</p>
                                    </div>
                                    <div className="find-by-card-content-icon">
                                        <TrendingFlatIcon />
                                    </div>
                                </div>
                            </div>
                            <div className="   couponcodemen-recuiter">
                                <img src="/image/couponcodemen.png" alt="" />
                                <div className="find-by-card-content">
                                    <div className="find-by-card-content-data">
                                        <h4>Get 10% off*</h4>
                                        <h5>Buy Premium Subscription <br /> and earn more.</h5>
                                        <h6>Use Coupon code</h6>
                                        <div className='coupon-code-name'>{RecuitercouponCode}</div>
                                        <div style={{ fontSize: "13px", paddingTop: "5px", cursor: "pointer", color: "navy" }} onClick={recuiterCopyCouponCode}>Copy Coupon Code</div>
                                    </div>
                                    <div className="find-by-card-content-icon">
                                        <TrendingFlatIcon />
                                    </div>
                                </div>
                            </div>

                        </>) :
                            (<>
                                <div onClick={() => handlewithoutlogin("find-project")} className="find-card">
                                    <img src="/image/findcardimg1.webp" alt="" />
                                    <div className="find-by-card-content">
                                        <div className="find-by-card-content-data">
                                            <h5>Find Project</h5>
                                            <p>Discover Your Next Big Project.</p>
                                        </div>
                                        <div className="find-by-card-content-icon">
                                            <TrendingFlatIcon />
                                        </div>
                                    </div>

                                </div>
                                <div onClick={() => handlewithoutlogin("find-job")} className="find-card">
                                    <img src="/image/findcardimg2.webp" alt="" />
                                    <div className="find-by-card-content">
                                        <div className="find-by-card-content-data">
                                            <h5>Find Job</h5>
                                            <p>Secure Your Ideal Position.</p>
                                        </div>
                                        <div className="find-by-card-content-icon">
                                            <TrendingFlatIcon />
                                        </div>

                                    </div>


                                </div>
                                <div onClick={() => handlewithoutlogin("post-job-project")} className="find-card">
                                    <img src="/image/findcardimg3.webp" alt="" />
                                    <div className="find-by-card-content">
                                        <div className="find-by-card-content-data">
                                            <h5>Post Project/Job</h5>
                                            <p>Connect with Top Talent Today.</p>
                                        </div>
                                        <div className="find-by-card-content-icon">
                                            <TrendingFlatIcon />
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => handlewithoutlogin("find-talent")} className="find-card">
                                    <img src="/image/findcardimg4.webp" alt="" />
                                    <div className="find-by-card-content">
                                        <div className="find-by-card-content-data">
                                            <h5>Find Talents</h5>
                                            <p>Hire the Best for Your Team.</p>
                                        </div>
                                        <div className="find-by-card-content-icon">
                                            <TrendingFlatIcon />
                                        </div>
                                    </div>
                                </div>
                            </>)}

                </div>
            </div>
        </>
    )
}

export default FindByCard
